import { createElement, ReactNode } from 'react';
import longhand from '@team-griffin/css-longhand';
import { useStyles } from '@team-griffin/stylr';
import { useTheme, Colorway } from '@uds/theme-utils';
import { getBodyColor } from 'presentation/utils/colorway';

interface OuterProps {
  colorway: Colorway;
  children?: ReactNode;
  ['data-sourcepos']?: string;
}

const useStylesheet = ({ colorway }: { colorway: Colorway }) => {
  const { theme } = useTheme();

  return useStyles({
    default: {
      root: {
        height: 0,
        ...longhand('border', {
          style: 'solid',
          width: 1,
          color: getBodyColor(theme, colorway),
        }),
      },
    },
  });
};

const PureThematicBreak = ({ colorway, children, ...props }: OuterProps) => {
  const { styles } = useStylesheet({ colorway });
  const itemProps = props['data-sourcepos'] ?? {};

  return createElement(
    'hr',
    {
      ...itemProps,
      style: styles.root,
    },
    children,
  );
};

PureThematicBreak.displayName = 'LegalDocumentThematicBreak';

export default PureThematicBreak;
